// extracted by mini-css-extract-plugin
export default {"pill":"styles-module__pill___BMZN4"};